module.exports = __webpack_public_path__ + "assets/img/right_active_icon.c700d3f6.png";